/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsImageSequenceAnimation = {
  init: function($section) {
    var animationFactory = new AnimationFactory();
    Shopify.theme.jsImageSequenceAnimation = $.extend(this, Shopify.theme.getSectionData($section));
    this.$section = $section
    
    let _self = this
    const $seq = $section.find('[data-sequence]')
    const args = {}
    _self.obj = {curImg: _self.start};
    this.getImages();
    args.$section = $section;
    args.$seq = $seq
    args.obj = _self.obj
    args.span = _self.span;
    args.images = _self.images;
    args.trigger = _self.trigger;
    args.tween = {
      duration:10,
    };
    args.scene = {
      triggerElement:`#shopify-section-${_self.trigger}`,
      duration:3000
    };
   setTimeout(function(){
    $section.removeClass('hidden')
    animationFactory.createAnimation(_self.obj,args)
   },_self.delay_by_seconds*1000)

  },
  getImages: function(){
    let images = []
      for(let index = this.start; index<=this.end ;index++){
       images.push(this.url.replace('[SEQUENCE]',`${index}${this.img_size}`))
      }
    this.images = images;
  },
  blockSelect: function($section, blockId) {
    
  },
  unload: function($section) {
    
  }
}

/******/ })()
;